/** Terms & Conditions content from https://cprerutlandandlincs.uk/terms-conditions/ */

export const termsSections = [
  {
    title: "Ts & Cs",
    paragraphs: [
      "All material contained within the Campaign to Protect Rural England (UK) website (www.cprerutlandandlincs.uk) is covered by a disclaimer and protected by copyright laws. Access to this website is subject to the following conditions",
    ],
  },
  {
    title: "Copyrights",
    paragraphs: [
      "Except as expressly stated in this site, no part of this website, including information, images, logos, photos and overall appearance of the site may be copied, republished, broadcast or reproduced in any form whatsoever without the prior written permission of the copyright holders except for your own personal or non-commercial use.",
    ],
  },
  {
    title: "Trademarks",
    paragraphs: [
      "'Campaign to Protect Rural England' and the 'Campaign to Protect Rural England' (CPRE) logo are trademarks. All other trademarks and logos used in this website are the trademarks or logos of their respective owners.",
    ],
  },
  {
    title: "Links to other websites",
    paragraphs: [
      "This website contains links to other websites that are operated by third parties. CPRE does not accept any liability over the content of these third party sites. The existence of these links does not constitute an endorsement of such websites, and your linking to these sites is at your own risk.",
    ],
  },
  {
    title: "Content accuracy",
    paragraphs: [
      "While all reasonable efforts have been made to ensure the accuracy of content, no responsibility can be taken for any error or omission.",
    ],
  },
  {
    title: "Limitation of liability",
    paragraphs: [
      "CPRE, the countryside charity, does not guarantee that access to this website will be uninterrupted, that this website will be free from viruses or that this website cannot be tampered with by third parties. This website and the information are provided on an 'as is' basis, with no warranties of any kind whatsoever, either express or implied, including, but not limited to, any warranties or any implied warranties of merchantability or fitness for a particular purpose. Use of this website and the information is entirely at the user's sole risk. In no event will CPRE be liable for any damages whatsoever arising out of or related to this website.",
      "Your sole and exclusive remedy for dissatisfaction with this website and/or information is to stop using the site and the information",
    ],
  },
  {
    title: "Modification of the terms and conditions",
    paragraphs: [
      "CPRE may modify the terms of this agreement on this site. You agree to periodically review this agreement to be aware of any such revisions. Should the revision be unacceptable to you, you agree to stop accessing this site. Your continued use of this website following such notification of any such revision(s) shall be deemed as acceptance of and agreement to abide by all such revisions.",
    ],
  },
];
